export const SET_ARCHITECTUTE_EDITOR_VALUE = "SET_ARCHITECTUTE_EDITOR_VALUE";

export const setArchitectureEditorValue = (architectureEditorValue) => ({
  type: SET_ARCHITECTUTE_EDITOR_VALUE,
  payload: architectureEditorValue,
});
